export const NAME = 'dashboard'
export const LABEL = 'Dashboard'
export const PATH = `/${NAME}/`
